{
	"borderRadius": {
		"cardSmall": "8px",
		"cardMedium": "16px",
		"cardLarge": "16px",
		"cardHuge": "24px",
		"modal": "16px",
		"default": "8px",
		"small": "4px"
	},
	"cardPadding": {
		"small": "16px",
		"medium": "16px",
		"large": "24px",
		"huge": "32px"
	},
	"lineHeight": {
		"default": "1.25"
	},
	"fontSize": {
		"default": "16px",
		"cardTitleSmall": "16px",
		"cardTitleMedium": "18px",
		"cardTitleLarge": "22px",
		"cardTitleHuge": "28px",
		"buttonTiny": "12px",
		"buttonSmall": "14px",
		"button": "14px",
		"buttonLarge": "16px",
		"alert": "12px"
	},
	"fontWeight": {
		"default": "400",
		"strong": "600",
		"cardTitle": "500",
		"formLabel": "400",
		"tabActive": "600",
		"button": "500",
		"buttonStrong": "700",
		"stepHeader": "400"
	},
	"fontFamily": {
		"default": "'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
		"display": "'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
		"mono": "'JetBrains Mono', SFMono-Regular, Menlo, Consolas, Courier, monospace"
	},
	"typography": {
		"h1": {
			"fontFamily": "{fontFamily.display}",
			"fontSize": "30px",
			"fontWeight": "700",
			"lineHeight": "38"
		},
		"h2": {
			"fontFamily": "{fontFamily.display}",
			"fontSize": "26px",
			"fontWeight": "700",
			"lineHeight": "33"
		},
		"h3": {
			"fontFamily": "{fontFamily.display}",
			"fontSize": "22px",
			"fontWeight": "700",
			"lineHeight": "28"
		},
		"h4": {
			"fontFamily": "{fontFamily.display}",
			"fontSize": "18px",
			"fontWeight": "500",
			"lineHeight": "23"
		},
		"h5": {
			"fontFamily": "{fontFamily.display}",
			"fontSize": "14px",
			"fontWeight": "700",
			"lineHeight": "18"
		},
		"h6": {
			"fontFamily": "{fontFamily.default}",
			"fontSize": "12px",
			"fontWeight": "500",
			"lineHeight": "15"
		},
		"p": {
			"fontFamily": "{fontFamily.default}",
			"fontSize": "{fontSize.default}",
			"lineHeight": "20"
		}
	},
	"colors": {
		"light": {
			"sidebarBackground": "rgb(255, 255, 255)",
			"bodyBackground": "rgb(247, 248, 249)",
			"background": "rgb(255, 255, 255)",
			"backgroundSecondary": "rgba(247, 248, 249, 1)",
			"backgroundTertiary": "rgb(230, 232, 240)",
			"text": "rgba(25, 25, 33, 1)",
			"textSecondary": "rgba(58, 59, 69, 1)",
			"textTertiary": "rgba(109, 109, 126, 1)",
			"textPlaceholder": "rgb(109, 109, 126)",
			"border": "rgba(219, 219, 223, 1)",
			"hover": "rgba(221, 224, 225, 0.5)",
			"primary": "rgb(91, 32, 255)",
			"primary-100": "rgb(250, 249, 255)",
			"primary-200": "rgb(236, 234, 255)",
			"primary-300": "rgb(205, 199, 255)",
			"primary-400": "rgb(124, 128, 255)",
			"primary-500": "rgb(91, 32, 255)",
			"primary-700": "rgb(39, 0, 112)",
			"grey": "rgba(109, 109, 126, 1)",
			"grey-50": "rgba(247, 248, 249, 1)",
			"grey-100": "rgba(234, 234, 235, 1)",
			"grey-200": "rgba(219, 219, 223, 1)",
			"grey-300": "rgba(199, 199, 208, 1)",
			"grey-500": "rgba(109, 109, 126, 1)",
			"grey-700": "rgba(58, 59, 69, 1)",
			"grey-900": "rgba(25, 25, 33, 1)",
			"info": "rgba(47, 116, 255, 1)",
			"info-400": "rgba(217, 231, 255, 1)",
			"info-500": "rgba(47, 116, 255, 1)",
			"info-600": "rgba(13, 70, 180, 1)",
			"success": "rgba(43, 191, 88, 1)",
			"success-400": "rgba(214, 245, 222, 1)",
			"success-500": "rgba(43, 191, 88, 1)",
			"success-600": "rgba(26, 124, 56, 1)",
			"warning": "rgba(232, 160, 6, 1)",
			"warning-400": "rgba(254, 241, 199, 1)",
			"warning-500": "rgba(232, 160, 6, 1)",
			"warning-600": "rgba(148, 100, 3, 1)",
			"error": "rgba(231, 62, 48, 1)",
			"error-400": "rgba(255, 225, 222, 1)",
			"error-500": "rgba(231, 62, 48, 1)",
			"error-600": "rgba(152, 33, 22, 1)",
			"extra1": "rgb(97, 102, 255)",
			"extra2": "rgb(255, 97, 200)",
			"extra3": "rgb(255, 183, 0)",
			"extra4": "rgb(255, 0, 85)",
			"status-pregnancy": "rgba(238, 134, 181, 1)",
			"status-pregnancy-400": "rgba(253, 236, 244, 1)",
			"status-pregnancy-500": "rgba(238, 134, 181, 1)",
			"status-pregnancy-600": "rgba(122, 47, 83, 1)",
			"status-fertility": "rgba(82, 201, 192, 1)",
			"status-fertility-400": "rgba(230, 248, 246, 1)",
			"status-fertility-500": "rgba(82, 201, 192, 1)",
			"status-fertility-600": "rgba(21, 92, 89, 1)",
			"status-menopause": "rgba(169, 177, 230, 1)",
			"status-menopause-400": "rgba(244, 245, 253, 1)",
			"status-menopause-500": "rgba(169, 177, 230, 1)",
			"status-menopause-600": "rgba(69, 74, 119, 1)",
			"status-abortion": "rgba(109, 109, 126, 1)",
			"status-postpartum": "rgba(199, 199, 208, 1)"
		},
		"dark": {
			"sidebarBackground": "rgb(255, 255, 255)",
			"bodyBackground": "rgb(247, 248, 249)",
			"background": "rgb(255, 255, 255)",
			"backgroundSecondary": "rgb(242, 244, 249)",
			"backgroundTertiary": "rgb(230, 232, 240)",
			"text": "rgba(25, 25, 33, 1)",
			"textSecondary": "rgba(58, 59, 69, 1)",
			"textTertiary": "rgba(109, 109, 126, 1)",
			"textPlaceholder": "rgb(109, 109, 126)",
			"border": "rgba(219, 219, 223, 1)",
			"hover": "rgba(221, 224, 225, 0.5)",
			"primary": "rgb(90, 32, 255)",
			"primary-100": "rgb(250, 249, 255)",
			"primary-200": "rgb(236, 234, 255)",
			"primary-300": "rgb(205, 199, 255)",
			"primary-400": "rgb(124, 128, 255)",
			"primary-500": "rgb(90, 32, 255)",
			"primary-700": "rgb(39, 0, 112)",
			"grey": "rgba(109, 109, 126, 1)",
			"grey-50": "rgba(247, 248, 249, 1)",
			"grey-100": "rgba(234, 234, 235, 1)",
			"grey-200": "rgba(219, 219, 223, 1)",
			"grey-300": "rgba(199, 199, 208, 1)",
			"grey-500": "rgba(109, 109, 126, 1)",
			"grey-700": "rgba(58, 59, 69, 1)",
			"grey-900": "rgba(25, 25, 33, 1)",
			"info": "rgba(47, 116, 255, 1)",
			"info-400": "rgba(217, 231, 255, 1)",
			"info-500": "rgba(47, 116, 255, 1)",
			"info-600": "rgba(13, 70, 180, 1)",
			"success": "rgba(43, 191, 88, 1)",
			"success-400": "rgba(214, 245, 222, 1)",
			"success-500": "rgba(43, 191, 88, 1)",
			"success-600": "rgba(26, 124, 56, 1)",
			"warning": "rgba(232, 160, 6, 1)",
			"warning-400": "rgba(254, 241, 199, 1)",
			"warning-500": "rgba(232, 160, 6, 1)",
			"warning-600": "rgba(148, 100, 3, 1)",
			"error": "rgba(231, 62, 48, 1)",
			"error-400": "rgba(255, 225, 222, 1)",
			"error-500": "rgba(231, 62, 48, 1)",
			"error-600": "rgba(152, 33, 22, 1)",
			"extra1": "rgb(97, 102, 255)",
			"extra2": "rgb(255, 97, 200)",
			"extra3": "rgb(255, 183, 0)",
			"extra4": "rgb(255, 0, 85)",
			"status-pregnancy": "rgba(238, 134, 181, 1)",
			"status-pregnancy-400": "rgba(253, 236, 244, 1)",
			"status-pregnancy-500": "rgba(238, 134, 181, 1)",
			"status-pregnancy-600": "rgba(122, 47, 83, 1)",
			"status-fertility": "rgba(82, 201, 192, 1)",
			"status-fertility-400": "rgba(230, 248, 246, 1)",
			"status-fertility-500": "rgba(82, 201, 192, 1)",
			"status-fertility-600": "rgba(21, 92, 89, 1)",
			"status-menopause": "rgba(169, 177, 230, 1)",
			"status-menopause-400": "rgba(244, 245, 253, 1)",
			"status-menopause-500": "rgba(169, 177, 230, 1)",
			"status-menopause-600": "rgba(69, 74, 119, 1)",
			"status-abortion": "rgba(109, 109, 126, 1)",
			"status-postpartum": "rgba(199, 199, 208, 1)"
		}
	}
}
